import IconOptions from "%/dynamic-component-editor/bundles/icon-options";
import Icon from "%/dynamic-component-editor/options/icon";
import IconVariant from "%/dynamic-component-editor/options/icon-variant";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import IconColor from "%/dynamic-component-editor/options/icon-color";
import IconGap from "%/dynamic-component-editor/options/icon-gap";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";

const FALLBACK_ICON_GAP = "standard";
const FALLBACK_ICON_VARIANT = "primary";

export const SubscriptionPlanFeatureListMixin = {
  optionBundles: [
    IconOptions,
  ],
  options: [
    IconGap,
    new LayoutGap({
      default: "extraSmall",
    }),
  ],
  data() {
    return {
      Icon,
      IconVariant,
      IconSize,
      IconGap,
      LayoutGap,
    };
  },
  computed: {
    featureTexts() {
      return [];
    },
    featureRowGap() {
      return this.getOptionValue(IconGap) || FALLBACK_ICON_GAP;
    },
    iconStyleOverrides() {
      const iconColor = this.getOptionValue(IconColor);
      if (!iconColor) {
        return {};
      }
      const variant = this.getOptionValue(IconVariant) || FALLBACK_ICON_VARIANT;
      return { [`${variant}VariantColor`]: iconColor };
    },
  },
};

export default SubscriptionPlanFeatureListMixin;
